import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBridge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBridge"><Circle cx="5" cy="16.5" r="2.5" stroke="currentColor"/><Circle cx="19" cy="16.5" r="2.5" stroke="currentColor"/><Path d="M5 14V12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12V14" stroke="currentColor"/></CentralIconBase>;
});

export default IconBridge;
